const testimonials = [
  {
    name: "Jennifer L.",
    location: "Alpharetta, GA",
    rating: 5,
    text: "My husband's business trip to London was moved up to 4 days out. We live in Alpharetta and panicked. Fast Passport Center had his emergency passport in hand in 3 days. The process was so smooth I couldn't believe it.",
    service: "Emergency Passport",
  },
  {
    name: "Michael R.",
    location: "Johns Creek, GA",
    rating: 5,
    text: "We booked a family cruise to the Caribbean and realized my son's passport was expired. Fast Passport Center walked us through the child passport process, told us exactly which clerk to visit near Alpharetta, and had everything ready with time to spare.",
    service: "Child Passport",
  },
  {
    name: "Sarah K.",
    location: "Roswell, GA",
    rating: 5,
    text: "I lost my passport two weeks before a conference in Germany. Fast Passport Center handled the replacement, guided me through the DS-64 form, and shipped everything overnight from Alpharetta. Got my expedited passport in 5 days. Incredible service.",
    service: "Lost Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AlpharettaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What North Metro Atlanta Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Alpharetta, Johns Creek, Roswell, and north metro Atlanta who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}